import * as SearchConstants from '../../action/search/SearchConstants';
import _ from 'lodash';

const initialState = {
  newBatchOfBlacklistedDomainDataIsFetching: false,
  newBatchOfBlacklistedDomainData: {},
  newBatchOfBlacklistedDomainDataErrorMessage: '',

  deleteDomainFromBlacklistDataIsFetching: false,
  deleteDomainFromBlacklistData: {},
  deleteDomainFromBlacklistDataErrorMessage: '',

  imagesTableFieldsDataIsFetching: false,
  imagesTableFieldsData: [],
  imagesTableFieldsDataErrorMessage: '',

  getDomainByNameIsLoading: false,
  getDomainByNameData: {},
  getDomainByNameErrorMessage: '',

  getDomainsByUsageUrlIsLoading: false,
  getDomainsByUsageUrlData: {},
  getDomainsByUsageUrlErrorMessage: '',

  getDomainsByClickhouseUsageUrlIsLoading: false,
  getDomainsByClickhouseUsageUrlData: {},
  getDomainsByClickhouseUsageUrlErrorMessage: '',

  getBlacklistedDomainByNameIsLoading: false,
  getBlacklistedDomainByNameData: {},
  getBlacklistedDomainByNameErrorMessage: '',

  getImagesByAgencyAndIdIsLoading: false,
  getImagesByAgencyAndIdData: {},
  getImagesByAgencyAndIdErrorMessage: '',

  getDomainFlowStatusesIsLoading: false,
  getDomainFlowStatusesData: {},
  getDomainFlowStatusesErrorMessage: '',

  getCountriesListIsLoading: false,
  getCountriesListData: [],
  getCountriesListErrorMessage: '',

  usageImagesData: {},

  getUsageUrlCountIsLoading: false,
  getUsageUrlCountData: {},
  getUsageUrlCountErrorMessage: ''
};

export const searchStore = (state = initialState, action) => {
  switch (action.type) {
    case SearchConstants.ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_REQUEST:
      return {
        ...state,
        newBatchOfBlacklistedDomainDataIsFetching: true,
        newBatchOfBlacklistedDomainDataErrorMessage: ''
      };
    case SearchConstants.ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_SUCCESS:
      return {
        ...state,
        newBatchOfBlacklistedDomainDataIsFetching: false,
        newBatchOfBlacklistedDomainData: action.data
      };
    case SearchConstants.ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_FAILED:
      return {
        ...state,
        newBatchOfBlacklistedDomainDataIsFetching: false,
        // saveMultipleImagesStatusErrorMessage: 'SERVER ERROR',
        newBatchOfBlacklistedDomainDataErrorMessage: action.error.response.data
      };
    case SearchConstants.ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_CLEAR:
      return {
        ...state,
        newBatchOfBlacklistedDomainDataIsFetching: false,
        newBatchOfBlacklistedDomainData: [],
        newBatchOfBlacklistedDomainDataErrorMessage: ''
      };

    case SearchConstants.DELETE_DOMAIN_FROM_BLACKLIST_REQUEST:
      return {
        ...state,
        deleteDomainFromBlacklistDataIsFetching: true,
        deleteDomainFromBlacklistDataErrorMessage: ''
      };
    case SearchConstants.DELETE_DOMAIN_FROM_BLACKLIST_SUCCESS:
      return {
        ...state,
        deleteDomainFromBlacklistDataIsFetching: false,
        deleteDomainFromBlacklistData: action.data
      };
    case SearchConstants.DELETE_DOMAIN_FROM_BLACKLIST_FAILED:
      return {
        ...state,
        deleteDomainFromBlacklistDataIsFetching: false,
        deleteDomainFromBlacklistDataErrorMessage: action.error.response.data
      };
    case SearchConstants.DELETE_DOMAIN_FROM_BLACKLIST_CLEAR:
      return {
        ...state,
        deleteDomainFromBlacklistDataIsFetching: false,
        deleteDomainFromBlacklistData: {},
        deleteDomainFromBlacklistDataErrorMessage: ''
      };

    case SearchConstants.GET_IMAGES_TABLE_FIELDS_DATA_REQUEST:
      return {
        ...state,
        imagesTableFieldsDataIsFetching: true,
        imagesTableFieldsDataErrorMessage: ''
      };
    case SearchConstants.GET_IMAGES_TABLE_FIELDS_DATA_SUCCESS:
      return {
        ...state,
        imagesTableFieldsDataIsFetching: false,
        imagesTableFieldsData: action.data
      };
    case SearchConstants.GET_IMAGES_TABLE_FIELDS_DATA_FAILED:
      return {
        ...state,
        imagesTableFieldsDataIsFetching: false,
        // saveMultipleImagesStatusErrorMessage: 'SERVER ERROR',
        imagesTableFieldsDataErrorMessage: action.error.response.data
      };
    case SearchConstants.GET_IMAGES_TABLE_FIELDS_DATA_CLEAR:
      return {
        ...state,
        imagesTableFieldsDataIsFetching: false,
        imagesTableFieldsData: {},
        imagesTableFieldsDataErrorMessage: ''
      };

    case SearchConstants.GET_DOMAIN_BY_NAME_REQUEST:
      return {
        ...state,
        getDomainByNameIsLoading: true,
        getDomainByNameErrorMessage: ''
      };
    case SearchConstants.GET_DOMAIN_BY_NAME_SUCCESS:
      return {
        ...state,
        getDomainByNameIsLoading: false,
        getDomainByNameData: action.data
      };
    case SearchConstants.GET_DOMAIN_BY_NAME_FAILED:
      return {
        ...state,
        getDomainByNameIsLoading: false,
        getDomainByNameErrorMessage: action.error.message
      };

    case SearchConstants.GET_DOMAINS_BY_USAGE_URL_REQUEST:
      return {
        ...state,
        getDomainsByUsageUrlIsLoading: true,
        getDomainsByUsageUrlErrorMessage: ''
      };
    case SearchConstants.GET_DOMAINS_BY_USAGE_URL_SUCCESS:
      return {
        ...state,
        getDomainsByUsageUrlIsLoading: false,
        getDomainsByUsageUrlData: action.data
      };
    case SearchConstants.GET_DOMAINS_BY_USAGE_URL_FAILED:
      return {
        ...state,
        getDomainsByUsageUrlIsLoading: false,
        getDomainsByUsageUrlErrorMessage: action.error
      };

    case SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_REQUEST:
      return {
        ...state,
        getDomainsByClickhouseUsageUrlIsLoading: true,
        getDomainsByClickhouseUsageUrlErrorMessage: ''
      };
    case SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_SUCCESS:
      return {
        ...state,
        getDomainsByClickhouseUsageUrlIsLoading: false,
        getDomainsByClickhouseUsageUrlData: action.data
      };
    case SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_FAILED:
      return {
        ...state,
        getDomainsByClickhouseUsageUrlIsLoading: false,
        getDomainsByClickhouseUsageUrlErrorMessage: action.error
      };

    case SearchConstants.GET_BLACKLISTED_DOMAIN_BY_NAME_REQUEST:
      return {
        ...state,
        getBlacklistedDomainByNameIsLoading: true,
        getBlacklistedDomainByNameErrorMessage: ''
      };
    case SearchConstants.GET_BLACKLISTED_DOMAIN_BY_NAME_SUCCESS:
      return {
        ...state,
        getBlacklistedDomainByNameIsLoading: false,
        getBlacklistedDomainByNameData: action.data
      };
    case SearchConstants.GET_BLACKLISTED_DOMAIN_BY_NAME_FAILED:
      return {
        ...state,
        getBlacklistedDomainByNameIsLoading: false,
        getBlacklistedDomainByNameErrorMessage: action.error.response.data
      };

    case SearchConstants.GET_IMAGES_BY_AGENCY_AND_ID_REQUEST:
      return {
        ...state,
        getImagesByAgencyAndIdIsLoading: true,
        getImagesByAgencyAndIdErrorMessage: ''
      };
    case SearchConstants.GET_IMAGES_BY_AGENCY_AND_ID_SUCCESS:
      return {
        ...state,
        getImagesByAgencyAndIdIsLoading: false,
        getImagesByAgencyAndIdData: action.data
      };
    case SearchConstants.GET_IMAGES_BY_AGENCY_AND_ID_FAILED:
      return {
        ...state,
        getImagesByAgencyAndIdIsLoading: false,
        getImagesByAgencyAndIdErrorMessage: action.error.response.data
      };

    case SearchConstants.GET_DOMAIN_FLOW_STATUSES_REQUEST:
      return {
        ...state,
        getDomainFlowStatusesIsLoading: true,
        getDomainFlowStatusesErrorMessage: ''
      };
    case SearchConstants.GET_DOMAIN_FLOW_STATUSES_SUCCESS:
      return {
        ...state,
        getDomainFlowStatusesIsLoading: false,
        getDomainFlowStatusesData: action.data
      };
    case SearchConstants.GET_DOMAIN_FLOW_STATUSES_FAILED:
      return {
        ...state,
        getDomainFlowStatusesIsLoading: false,
        getDomainFlowStatusesErrorMessage: action.error.response.data
      };

    case SearchConstants.GET_COUNTRIES_LIST_REQUEST:
      return {
        ...state,
        getCountriesListIsLoading: true,
        getCountriesListErrorMessage: ''
      };
    case SearchConstants.GET_COUNTRIES_LIST_SUCCESS:
      return {
        ...state,
        getCountriesListIsLoading: false,
        getCountriesListData: action.data
      };
    case SearchConstants.GET_COUNTRIES_LIST_FAILED:
      return {
        ...state,
        getCountriesListIsLoading: false,
        getCountriesListErrorMessage: action.error.response.data
      };

    case SearchConstants.CHANGE_USAGE_IMAGES_DATA:
      let newImages = _.cloneDeep(state.getDomainsByUsageUrlData);

      action.payload.imageIds.forEach((idx) => {
        const record = newImages?.content?.find(({ id }) => id === idx);
        if (record) {
          record.status = action.payload.status;
        }
      });

      return {
        ...state,
        getDomainsByUsageUrlData: newImages
      };

    case SearchConstants.CHANGE_CLICKHOUSE_USAGE_IMAGES_DATA:
      let newClickhouseImages = _.cloneDeep(
        state.getDomainsByClickhouseUsageUrlData
      );

      action.payload.imageIds.forEach((idx) => {
        const record = newClickhouseImages?.content?.find(
          ({ id }) => id === idx
        );
        if (record) {
          record.status = action.payload.status;
        }
      });

      return {
        ...state,
        getDomainsByClickhouseUsageUrlData: newClickhouseImages
      };

    case SearchConstants.GET_USAGE_URL_COUNT_REQUEST:
      return {
        ...state,
        getUsageUrlCountIsLoading: true,
        getUsageUrlCountErrorMessage: ''
      };
    case SearchConstants.GET_USAGE_URL_COUNT_SUCCESS:
      return {
        ...state,
        getUsageUrlCountIsLoading: false,
        getUsageUrlCountData: action.data
      };
    case SearchConstants.GET_USAGE_URL_COUNT_FAILED:
      return {
        ...state,
        getUsageUrlCountIsLoading: false,
        getUsageUrlCountErrorMessage: 'Counting error'
      };

    default:
      return state;
  }
};
